<template>
  <div>
    <custom-actions>
      <el-form inline :model="searchForm" @submit.native.prevent="search">
        <el-form-item label="工单来源">
          <el-select v-model="searchForm.source" clearable placeholder="全部来源">
            <el-option v-for="item in sources" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="工单号">
          <el-input v-model.trim="searchForm.workOrderNo" clearable placeholder="请输入完整工单号" @keyup.enter.native="search" />
        </el-form-item>
        <el-form-item label="推送结果">
          <el-select v-model="searchForm.pushResult" clearable placeholder="全部结果">
            <el-option label="成功" :value="1" />
            <el-option label="失败" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :disabled="!canQuery" @click="search">查询</el-button>
          <el-button :disabled="!canQuery" @click="reset">重置</el-button>
          <el-button :disabled="!canQuery" @click="loadData">刷新</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-alert v-if="!canQuery" class="mt10" type="warning" :closable="false" title="当前账号没有推送记录查询权限，请联系管理员授权。" />
    <el-card v-else shadow="never" class="mt10">
      <el-table v-loading="loading" :data="rows" size="mini" stripe border row-key="recordId" empty-text="暂无推送记录">
        <el-table-column label="工单来源" min-width="160">
          <template v-slot="{ row }">{{ sourceName(row.source) }}</template>
        </el-table-column>
        <el-table-column label="工单号" prop="workOrderNo" min-width="190" show-overflow-tooltip />
        <el-table-column label="推送结果" width="110">
          <template v-slot="{ row }">
            <el-tag :type="Number(row.retrying) === 1 ? 'warning' : Number(row.pushResult) === 1 ? 'success' : 'danger'">
              {{ resultName(row) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="重试次数" prop="retryCount" width="90" />
        <el-table-column label="首次推送时间" min-width="165">
          <template v-slot="{ row }">{{ formatTime(row.createTime) }}</template>
        </el-table-column>
        <el-table-column label="最近更新时间" min-width="165">
          <template v-slot="{ row }">{{ formatTime(row.updateTime) }}</template>
        </el-table-column>
        <!-- 删除对所有列表用户可见，操作列不能再随详情、重试权限一起隐藏。 -->
        <el-table-column label="操作" width="200" fixed="right">
          <template v-slot="{ row }">
            <el-button v-if="canDetail" type="text" :disabled="detailLoading" @click="showDetail(row)">详情</el-button>
            <el-button v-if="canRetry && Number(row.pushResult) === 2" type="text"
              :disabled="Number(row.retrying) === 1 || busyIds.includes(row.recordId) || deletingIds.includes(row.recordId)"
              :loading="busyIds.includes(row.recordId)" @click="retry(row)">重试</el-button>
            <el-button type="text" class="del-btn"
              :disabled="Number(row.retrying) === 1 || busyIds.includes(row.recordId) || deletingIds.includes(row.recordId)"
              :loading="deletingIds.includes(row.recordId)" @click="deleteRecord(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="mt15" :current-page.sync="page" :page-size="size" :page-sizes="[10, 20, 50, 100]"
        :total="total" layout="total, sizes, prev, pager, next" background
        @current-change="loadData" @size-change="changeSize" />
    </el-card>

    <el-dialog title="T+推送详情" :visible.sync="visible" width="80%">
      <div v-loading="detailLoading">
        <p>工单来源：{{ sourceName(detail.source) }} / 工单号：{{ detail.workOrderNo }}</p>
        <p>推送结果：{{ resultName(detail) }} / 重试次数：{{ detail.retryCount || 0 }}</p>
        <p>记录 ID：{{ detail.recordId }}</p>
        <p>推送内容</p>
        <pre class="push-content">{{ formatContent(detail.pushContent) }}</pre>
        <p>返回结果 / 失败原因</p>
        <pre class="push-content">{{ formatContent(detail.responseContent) }}</pre>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'TplusPushRecord',
  data () {
    return {
      // 来源值对应后端业务任务类型，采购子单退货和完成分别沿用各自重试规则。
      sources: [
        { value: '销售', label: '云销提货' },
        { value: '销售子单', label: '云销暂定价子单' },
        { value: '采购', label: '云采提货' },
        { value: '采购子单', label: '云采子单退货' },
        { value: '采购子单完成', label: '云采暂定价子单完成' },
        { value: '云销资金', label: '云销充值退款' },
        { value: '云采资金', label: '云采充值退款' }
      ],
      searchForm: { source: '', workOrderNo: '', pushResult: '' },
      rows: [],
      total: 0,
      page: 1,
      size: 10,
      loading: false,
      // 只接受最后一次筛选的结果，避免较慢的旧请求覆盖当前页面。
      querySequence: 0,
      // 每条记录独立锁定重试按钮，服务端仍会校验失败状态并原子占用。
      busyIds: [],
      // 确认及删除期间锁定当前行，防止重复弹窗或与重试同时提交。
      deletingIds: [],
      detail: {},
      detailLoading: false,
      visible: false
    }
  },
  computed: {
    isAdmin () { return String(this.$store.state.user.isAdmin) === '1' },
    permissions () { return this.$store.getters.getMenuByCode('TPL') },
    canQuery () { return this.isAdmin || this.permissions.includes('TPL_SEL_01') },
    canDetail () { return this.isAdmin || this.permissions.includes('TPL_SEL_02') },
    canRetry () { return this.isAdmin || this.permissions.includes('TPL_EDT_01') }
  },
  watch: {
    // 菜单授权可能在页面初始化后加载，权限就绪后再查询，避免把未授权当作无数据。
    canQuery (allowed) { if (allowed) this.search() }
  },
  created () { this.loadData() },
  methods: {
    sourceName (source) {
      const item = this.sources.find(item => item.value === source)
      return item ? item.label : (source || '-')
    },
    resultName (record) {
      if (Number(record.retrying) === 1) return '推送中'
      if (Number(record.pushResult) === 1) return '成功'
      return Number(record.pushResult) === 2 ? '失败' : '-'
    },
    formatTime (value) { return value ? this.$dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '-' },
    formatContent (value) {
      if (!value) return '无'
      // 报文仅作为文本展示；JSON 格式化失败时保留原始异常内容，不执行返回的 HTML。
      try { return JSON.stringify(JSON.parse(value), null, 2) } catch (error) { return value }
    },
    search () { this.page = 1; this.loadData() },
    reset () { this.searchForm = { source: '', workOrderNo: '', pushResult: '' }; this.search() },
    changeSize (size) { this.size = size; this.search() },
    async loadData () {
      if (!this.canQuery) return
      const sequence = ++this.querySequence
      this.loading = true
      try {
        const params = { page: this.page, size: this.size, ...this.searchForm }
        const result = await this.$axios.get(this.$apis.system.tplusPushRecordPage, { params })
        if (sequence !== this.querySequence) return
        this.rows = result.list || []
        this.total = result.total || 0
      } catch (error) {
        // 公共请求拦截器已提示错误，清理旧结果以免被误认成本次查询的数据。
        if (sequence === this.querySequence) { this.rows = []; this.total = 0 }
      } finally {
        if (sequence === this.querySequence) this.loading = false
      }
    },
    async showDetail (row) {
      if (!this.canDetail || this.detailLoading) return
      this.detail = { ...row }
      this.visible = true
      this.detailLoading = true
      try {
        this.detail = await this.$axios.get(this.$apis.system.tplusPushRecordDetail, { recordId: row.recordId })
      } catch (error) {
        this.visible = false
      } finally { this.detailLoading = false }
    },
    async deleteRecord (row) {
      if (Number(row.retrying) === 1 || this.busyIds.includes(row.recordId) || this.deletingIds.includes(row.recordId)) return
      this.deletingIds.push(row.recordId)
      try {
        await this.$confirm('确认删除该推送记录？删除后无法恢复，原业务单据和 T+ 单据保留。', '删除确认', {
          confirmButtonText: '删除', cancelButtonText: '取消', type: 'warning'
        })
        // 仅提交本地记录主键，服务端原子校验推送状态，不需要按钮权限字段。
        await this.$axios.post(this.$apis.system.tplusPushRecordDelete,
          { recordId: row.recordId }, { showSuccessMessage: false })
        this.$message.success('删除成功')
        if (this.visible && this.detail.recordId === row.recordId) this.visible = false
        // 删除当前末页唯一一条记录时退回上一页，保留用户当前筛选条件。
        if (this.page > 1 && this.rows.length === 1 && this.rows[0].recordId === row.recordId) this.page -= 1
        await this.loadData()
      } catch (error) {
        // 取消确认不产生请求；接口失败沿用公共拦截器提示，保留原列表以便重试。
      } finally {
        this.deletingIds = this.deletingIds.filter(id => id !== row.recordId)
      }
    },
    async retry (row) {
      if (!this.canRetry || Number(row.pushResult) !== 2 || Number(row.retrying) === 1 || this.busyIds.includes(row.recordId)) return
      this.busyIds.push(row.recordId)
      try {
        // 仅提交记录主键，由后端重新查询工单；请求成功提示由实际推送结果决定。
        const result = await this.$axios.post(this.$apis.system.tplusPushRecordRetry,
          { recordId: row.recordId }, { showSuccessMessage: false })
        if (Number(result.pushResult) === 1) this.$message.success('推送成功')
        else this.$message.error('推送失败，请查看详情中的返回结果')
        if (this.visible && this.detail.recordId === row.recordId) this.detail = result
      } catch (error) {
        // 保留拦截器的具体异常提示，随后刷新状态，避免网络超时后直接再次提交。
      } finally {
        await this.loadData()
        this.busyIds = this.busyIds.filter(id => id !== row.recordId)
      }
    }
  }
}
</script>

<style scoped>
.push-content {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  max-height: 320px;
  overflow: auto;
  padding: 12px;
  background: #f5f7fa;
}
</style>
